import { useState } from 'react';
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';

import * as SVG from 'app/shared-components/Icons';

const Accordion = ({
  title,
  sx = {},
  children,
  summarySx = {},
  detailsSx = {},
  CustomTitle,
  defaultOpen = true,
  ...restProps
}) => {
  const [expanded, setExpanded] = useState(defaultOpen);
  const toggleAccordion = () => {
    setExpanded(!expanded);
  };

  return (
    <MuiAccordion
      sx={{
        '&.MuiAccordion-root': {
          '&:before': {
            display: 'none', // no bottom border line
          },
          boxShadow: 'none',
          backgroundColor: 'unset',
          border: 'none',
        },
        ...sx,
      }}
      expanded={expanded}
      onChange={toggleAccordion}
      disableGutters
      {...restProps}
    >
      <AccordionSummary
        sx={{
          paddingLeft: 0,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          margin: 0,
          minHeight: '30px',
          height: '30px',
          ...summarySx,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          {CustomTitle || <Typography variant="subtitle2">{title}</Typography>}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              transition: 'transform 0.2s ease-in-out',
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          >
            <SVG.CommonIcons iconId="carret-down" size={16} />
          </Box>
        </Box>
      </AccordionSummary>
      {expanded && <AccordionDetails sx={{ padding: 0, ...detailsSx }}>{children}</AccordionDetails>}
    </MuiAccordion>
  );
};

export default Accordion;
